/* eslint-disable react/no-danger */
import { Box, CircularProgress, Divider, Typography } from '@mui/material';
import { ApiError } from '@pro4-erp/core-web';
import { useQuery } from '@tanstack/react-query';
import { getBeautifiedLocalDate } from '@/core';
import { getClientLandingPage } from '../api/getClientLandingPage';
import { ClientLandingPage } from '../types';

const HomePage = () => {
  const query = useQuery<ClientLandingPage[], ApiError>(
    ['client-landing'],
    () => getClientLandingPage(),
    {
      refetchOnWindowFocus: false,
    }
  );

  if (query.isLoading) {
    return (
      <Box>
        <Box
          sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={100} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 1 }}>
      {query.data ? (
        query.data?.map((item) => (
          <Box sx={{ mb: 1 }} key={item.id}>
            <div dangerouslySetInnerHTML={{ __html: item.page }} />
            <Typography
              variant="subtitle2"
              component="p"
              sx={{ marginTop: '1.5rem', fontStyle: 'italic' }}
            >{`Objavil: ${item.author || '/'}, dne: ${
              item.dateCreated ? getBeautifiedLocalDate(item.dateCreated) : 'N/A'
            }`}</Typography>
            <Divider sx={{ marginBottom: '3rem' }} />
          </Box>
        ))
      ) : (
        <Box>
          <Typography>Homepage</Typography>
        </Box>
      )}
    </Box>
  );
};

export default HomePage;
